import React from 'react';

const SvgActions70 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 18 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.78.42l-1.94-1.3a.52.52 0 0 0-.56 0l-1.94 1.3A.5.5 0 0 1 10 9.5zM2 4v5H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H2v5H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions70 svgRef={ref} {...props} />);
export default ForwardRef;
